export default __webpack_public_path__ + "media/images/backgrounds/metal-detecting-bg-17ae05fe32d889ff0f8107c01a177751.png";